var __symbolPrefix = "3r/message-api/content/"

function embedMessageContent (_, Device, message, extra, overrideContent) {
    let content

    if (!message) {
        return ""
    }

    let source = _.extend({
        user: (Device.info.user || {}).ATTRIBUTES,
        data: (Device.info.user || {}).data,
        message: message,
        attachments: message.attachments,
        extra: extra || {},
        uid: Device.thrid,
        deviceId : Device.deviceId,
        permanentId : Device.permanentId
    }, (message || {}).extraContent || {}, extra)
    
    if (typeof overrideContent == 'string') {
        content = overrideContent
    } else if (typeof message == 'string') {
        content = message
    } else {
        content = message.markedUp
        let files = message.quantities.files ? (_(message.quantities.files.split('\n'))
                .map(f => f.split(';'))
                .flatten()
                .map(f => f.trim())
                .filter(f => f)
                .value()) : []
        source.files = files
        if (message.attachments && Array.isArray(message.attachments.files))
            files = files.concat(message.attachments.files)
        message.files = files

    }

    return content
        .replace(/\{\{([^\}]+)\}\}/ig, function (match, capture) {
            let value = _.get(source, capture, null)
            return value || ""
        })
        .replace(/\[\[([^\]]+)\]\]/ig, function (match, capture) {
            let value = Device.evaluateInContext(capture, extra)
            return '<span class="embedded-content">' + (value || "") + '</span>'
        })
        .replace(/\[\{([^\]\}]+)\}\]/ig, function (match, capture) {
            let value = Device.evaluateInContext(capture, extra)
            return (value || "")
        })
}

embedMessageContent._depends = {
    symbol : __symbolPrefix + "embedMessageContent",
    modules : [
        "_",
        "3r/Device"
    ]
}


function grouper (Promise, _, Device, embedMessageContent, hasCategory, schemeSettings, window, messageStaticLookup,  mapToType, name, category, title, click, listClick, mode, predicate, priority, canOpen, messages, results) {
    var mode = ((window && window[name + 'Mode']) || mode || 'multiple').toLowerCase()

    /* Doning this properly runs into closure issues with bable :/ */

    var lookups = messages.map(function(m) { 
        return messageStaticLookup(m)
    }).filter(Boolean)

    var available = _(messages)
        .filter(function (m) {
            return m && (!predicate || predicate(m))
        })
        .filter(hasCategory(category))
        .map(function (m) {
            var item
            m.istaken = true
            return item = {
                id: m.ATTRIBUTES.id,
                title: embedMessageContent(m.ATTRIBUTES.status.match(/redeemed/ig) && m.quantities.disableWhenRedeemed ? m.quantities.disabledMessage : m.title, m.extraContent || {}),
                categories: m.categories,
                classes: {
                    "disabled-item": m.ATTRIBUTES.status.match(/redeemed/ig) && m.quantities.disableWhenRedeemed
                },
                image: m.heroImage,
                rewards: m.categories.rewarding,
                teaser: embedMessageContent(m, m.extraContent || {}),
                count: m.ATTRIBUTES.status.match(/sent|received/ig) && schemeSettings.globals.hideNewItemIndicator != 'yes'
                    ? 1
                    : 0,
                priority: m.quantities.priority || m.quantities.manualPriority,
                message: m,
                click: function () {
                    return click(m, item)
                }
            }
        })
        .sortBy(function (m) {
            return m.message.ATTRIBUTES.status.match(/redeemed/ig) ? 100 : 1
        })
        .uniq(function (m) {
            if(m.message.quantities.allowDuplicates){
                return m.id
            }
            else{
                return m.message.systemId
            }
         })
        .sortBy(function (m) {
            return -m.priority
        })
        .value()

    available.forEach(function (m) {
        var entry = {
            id: m.id,
            systemId: m.message.systemId,
            categories: m.message.categories,
            item: m,
            state: name,
            category: category,
            click: m.click
        }
        var entries = mapToType.lookup[m.message.systemId] =
            mapToType.lookup[m.message.systemId] || []
        entries.push(entry)
        mapToType.lookup[m.message.systemId] = _.uniq(mapToType.lookup[m.message.systemId], 'id')
        mapToType.lookupById[m.id] = entry
        mapToType.all.push(entry)
        mapToType.all = _.uniq(mapToType.all, 'id')
    })

    available = _.filter(available, function (a) {
        return !a.categories['hidden']
    })

    results.push(_(available).filter(hasCategory.notGrouped).value())

    available = _(available).filter(hasCategory.grouped).value()

    let allLookups = Promise.all(lookups)

    if(available.length) {
        switch (mode) {
            case 'multiple':
                results.push(available)
                return allLookups
            case 'single':
                results.push(_(available).first())
                return allLookups
            case 'list':
                available = _.filter(available, function (m) {
                    return !m.categories.hideonhome
                })
                if (available.length > 1) {
                    results.push({
                        id: 'messagelist',
                        title: 'Messages',
                        teaser: "All of the messages you haven't read",
                        image: schemeSettings.globals.groupImage || 'images/group.png',
                        rewards: _(available).any(function (m) {
                            return m.rewards
                        }),
                        count: _(available).sum(function (a) {
                            return a.count
                        }),
                        priority: 150,
                        click: function () {
                            return listClick(m)
                        }
                    })
                } else if (available.length) {
                    results.push(available)
                }
                return allLookups
        }
    }
}

grouper._depends = {
    symbol : __symbolPrefix + "grouper",
    modules : [
        "Promise",
        "_",
        "3r/Device",
        __symbolPrefix + "embedMessageContent",
        "3r/message-api/helpers/hasCategory",
        "3r/schemeSettings/webapp",
        {
            symbol : "window",
            nullIfMissing : true
        },
        __symbolPrefix + "messageStaticLookup"
    ]
}

function messageStaticLookup(Device, m){
    if (!m.quantities.staticLookup || !m.quantities.staticLookupKey) {
        return
    }

    if (!m.quantities.staticLookup.match(/\//)) {
        return
    }

    if (m.extraContent) {
        return
    }

    if (m.lookupPromise) {
        return m.lookupPromise
    }

    let key = m.systemId

    switch (m.quantities.staticLookupKey) {
        case "origin":
            key = m.ATTRIBUTES.origin
            break
        case "userId":
            key = Device.permanentId
            break
    }

    if (!key && ["boolean", "number"].indexOf(typeof key) < 0) {
        return
    }

    return m.lookupPromise = Device.gtp("/static-lookup/objects/" + Device.schemeId + "/" + m.quantities.staticLookup + "/" + key)
        .then(function (results) {
            if (!results.rows || results.rows.length < 1) {
                return m
            }

            m.extraContent = results.rows[0] || {}

            return m
        })
        .catch(function (e) {
            if (e.status != 404) {
                console.warn(e)
            }

            return m
    })
}

messageStaticLookup._depends = {
    symbol : __symbolPrefix + "messageStaticLookup",
    modules : [
        "3r/Device"
    ]
}

if (typeof exports == "object") {
    exports.embedMessageContent = embedMessageContent
    exports.grouper = grouper
    exports.messageStaticLookup = messageStaticLookup
}

if (typeof window == "object" && window == this && this.ioc && typeof this.ioc.inject == "function") {
    window.grouper = grouper = this.ioc.inject(grouper)
}
